/**
 * Utility to clear all authentication-related data
 * Use this when you need to force a fresh login
 * 
 * This function clears:
 * - All cookies (including Clerk's __session and __client cookies)
 * - localStorage
 * - sessionStorage
 * 
 * Then redirects to the login page
 */
export function clearSession() {
  // Clear all cookies by setting them to expire in the past
  // We need to clear cookies for the current path and root path
  const cookies = document.cookie.split(';')
  
  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()
    
    if (name) {
      // Clear cookie for root path
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
      // Clear cookie for current path
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${window.location.pathname}`
      // Clear cookie for domain (if set)
      const hostname = window.location.hostname
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${hostname}`
      // Clear cookie for parent domain (for subdomains)
      const parts = hostname.split('.')
      if (parts.length > 1) {
        const parentDomain = '.' + parts.slice(-2).join('.')
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${parentDomain}`
      }
    }
  })

  // Clear localStorage
  localStorage.clear()

  // Clear sessionStorage
  sessionStorage.clear()

  // Reload the page to ensure clean state
  window.location.href = '/admin/login'
}

